import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { getHodSiteDetail, type HodSiteDetailParams } from '../api/hodSiteDetailApi'

// One queryOptions factory per (siteId + params) tuple.
// Route loader prefetches with the default params (no pagination cursor);
// component subscribes to the same key — single network round-trip on
// first render even with `defaultPreload: 'intent'`.
export const hodSiteDetailQueryOptions = (siteId: string, params?: HodSiteDetailParams) =>
  queryOptions({
    queryKey: ['hod-site-detail', siteId, params ?? null] as const,
    queryFn: () => getHodSiteDetail(siteId, params),
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  })

export function useHodSiteDetail(siteId: string, params?: HodSiteDetailParams) {
  return useQuery(hodSiteDetailQueryOptions(siteId, params))
}
